/**
 *
 * Base
 *
 */


import { Fancybox } from 'Fancybox';

Fancybox.bind( '[data-fancybox]', {
	buttons: [ 'close'],
	focus: false,
	hash: false,
	dragToClose: false,
	on: {
		destroy: ( fancybox ) => {
			let media = fancybox.$container.querySelector( 'video' );
			if ( media != null ) {
				media.pause();
				media.currentTime = 0;
			}
		}
	}
} );

Fancybox.bind( '[data-fancybox-help]', {
	buttons: [ 'close'],
	focus: false,
	hash: false,
	dragToClose: false,
} );
